import { Injectable } from '@angular/core';

import { EntityService } from '@vshosting/core';
import { CdnAlias } from "@vshosting/models";
import { ApiEntityKeys } from '../../app.constant';
import { AddAliasPayload } from './alias-base.model';

@Injectable({ providedIn: 'root' })
export class AliasEntity extends EntityService<CdnAlias, AddAliasPayload> {
  constructor() {
    super(ApiEntityKeys.Alias);
  }
}
